import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import {CopyToClipboard} from "react-copy-to-clipboard";
import Table from "../../components/Table/Table";
import ReactLoading from 'react-loading';
import moment from "moment/moment";


class CustomerAliasListModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
		    loading:false,
            aliasList:[]
		};
	}

	componentDidMount () {
		let self = this;
		let params = {
			url: `/gibuser/getCustomerAliasList`,
			method: "post",
            data:self.props.vknTckn
		};
		self.setState({loading:true});
		request(params)
		.then(function (response) {
			let aliasList = response.data;
			self.setState({aliasList,loading:false});
		}).catch(function (error) {
			showAxiosError(error);
            self.setState({loading:false});
		});
	}

    copied(Alias) {
        if (Alias) {
            Alert.success("Etiket: " + Alias + " kopyalandı", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html:false
            });
        }
    }

	render() {
        const columns = [
            {
                Header: "Etiket",
                accessor: "alias",
                sortable:false,
                Cell: row => (
                    <div>
                        <label>{row.alias}</label>
                        <CopyToClipboard text={row.alias}
                                         onCopy={() => this.copied(row.alias)}>
                            <button className="btn "
                                    style={{
                                        padding: "0px 9px 0px 9px",
                                        margin: "0px",
                                        backgroundColor: "inherit",
                                        color: "#78b1d7"
                                    }}>
                                <i className="far fa-copy"/>
                            </button>
                        </CopyToClipboard>
                    </div>
                )
            },
            {
                Header: "Kayıt Türü",
                accessor: "accountingType",
                sortable:false,
                Cell: row => (<div>{row.accountingType === 'OZELENTEGRASYON' ? "Özel Entegratör" : (row.accountingType === 'ENTEGRASYON' ? "Doğrudan Entegrasyon" : (row.accountingType === 'GIBPORTAL' ? "GİB Portal Kullanıcısı": "Bilinmeyen")) }</div>)
            },
            {
                Header: "Şirket Türü",
                accessor: "type",
                sortable:false,
            },
            {
                Header: "Etiket Türü",
                accessor: "documentType",
                sortable:false,
                Cell: row => (<div>{row.documentType === "Invoice" ? "E-Fatura" : (row.documentType === "DespatchAdvice" ? "E-İrsaliye" : "")}</div>)
            },
            {
                Header: "Oluşturulma Zamanı",
                accessor: "aliasCreationTime",
                sortable:false,
                Cell:(row)=> (<div>{moment(row.aliasCreationTime).isValid() ? moment(row.aliasCreationTime).format("DD-MM-YYYY HH:mm:ss") : ''}</div>)
            },
            {
                Header: "GB/PK",
                accessor: "statusType",
                sortable:false,
            }
        ];

		return (
			<DefaultModal disabled={this.state.confirmBtnDisabled}
						  isOpen={this.props.modal}
                          size="lg"
						  title={this.props.title || ""}
						  confirmBtnText=""
						  cancelBtnText="Kapat"
						  onCancel={()=>this.props.toggleModal(false)}
			>
                <div className="col-sm-12"
                     style={{position:"unset", margin:0, paddingTop:"4px", paddingBottom:"8px"}}>
                    <Table
                        columns={columns}
                        content={this.state.aliasList}
                        paginationEnabled={false}
                        loadingText={<ReactLoading type="spinningBubbles" style={{width:"45px", height: "45px", margin: "15px auto 0 auto", fill: "#888"}}/>}
                        loading={this.state.loading}
                        options={[]}
                        fetchData={()=>{}}
                    />
                </div>
			</DefaultModal>
		)
	}
}

export default CustomerAliasListModal;